/**
 * 移除本页轨迹相关图层/源（id 前缀为 track-*，含 casing / arrows）
 */
export function removeLocalTrackLayers(map, trackId) {
  if (!map || !trackId) return;
  [`${trackId}-arrows`, `${trackId}-line`, `${trackId}-casing`].forEach((layerId) => {
    try {
      if (map.getLayer?.(layerId)) map.removeLayer(layerId);
    } catch (_) {
      /* ignore */
    }
  });
  try {
    if (map.getSource?.(trackId)) map.removeSource(trackId);
  } catch (_) {
    /* ignore */
  }
}
